import type { Component } from "solid-js";

interface Props {
  value: string;
  onInput: (value: string) => void;
  disabled?: boolean;
  placeholder?: string;
}

export const SearchBox: Component<Props> = (props) => {
  return (
    <input
      class="search-box"
      type="search"
      value={props.value}
      placeholder={
        props.placeholder ?? "e.g. Where do they discuss blockchain in coffee supply chains?"
      }
      aria-label="Search the corpus"
      autocomplete="off"
      autocapitalize="off"
      spellcheck={false}
      disabled={props.disabled}
      onInput={(e) => props.onInput(e.currentTarget.value)}
    />
  );
};
